


























































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import Decisions from '@/store/modules/Decisions';
import { getModule } from 'vuex-module-decorators';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { NotificationEventBus } from '@/EventBus';
import _ from 'lodash';
import ListInputDialog from '@/components/forms/ListInputDialog.vue';
import Viewpoints from '@/store/modules/Viewpoints';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';
import { Viewpoint } from '@/api/model/Viewpoint';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { ViewpointChoiceFactor } from '@/api/model/ViewpointChoiceFactor';
import { ViewpointFactorResource } from '@/api/model/ViewpointFactorResource';

const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const WorkspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ListInputDialog,
        BasicInputForm,
    },
})
export default class ViewpointCreatorButton extends Vue {
    @Prop({ default: 'NEW', type: String })
    btnText!: string;

    @Prop({ default: false, type: Boolean })
    menuRight!: boolean

    @Prop({ default: false, type: Boolean })
    menuBottom!: boolean

    @Prop({ default: false, type: Boolean })
    offsetX!: boolean
    @Prop({ default: false, type: Boolean })
    offsetY!: boolean

    @Prop({ default: false, type: Boolean })
    menuLeft!: boolean


    private refreshing = false;
    private createViewpointDialog = false;
    private adding = false;
    private addToList = true;
    private selectedViewpoints = [];
    private generateViewpointDialog = false;
    private menuShow = false;
    private generationOptions = [
            'None',
            'Include Scores',
            'Include Slope',
            'Just Scores',
            'Scores to Ranks',
            'Weights to 3 bins quantile',
            'Decision Tree Weights',
    ];
    private generationFunctions = [{name: `Estimate Score From Ranking`, id: 'score_estimation_from_ranking'}, {name: `Generate Consensus ${this.singularViewpointLabel}`, id: 'generate_consensus_viewpoint'}]
    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get activeViewpointList() {
        return WorkspaceOptionsModule.activeViewpointLists;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get allowGenerateViewpoints() {
        return WorkspaceOptionsModule.allowGenerateViewpoints;
    }

    set allowGenerateViewpoints(val: boolean) {
        WorkspaceOptionsModule.setAllowGenerateViewpoints(val);
    }

    get viewpointList(): Viewpoint[] {
        return viewpointsModule.decisionViewpoints || [];
    }

    // Create Viewpoint(s) from a List
    private async createViewpointsFromList(payload: any) {
        let list = payload.names;
        let addToList = payload.addToList;
        let results = [];
        this.refreshing = true;
        if (list.length) {
            let viewpoints = list
                .filter((l) => l)
                .map((name) => {
                    return {
                        name: name,
                        addToList: addToList,
                    };
                });
            viewpoints.forEach((v: any) => {
                this.createViewpoint(v);
            });
        }
        this.refreshing = false;
    }

    private async createViewpoint(viewpoint: any) {
        if (!this.selectedDecision) return;
        this.adding = true;
        let sampleViewpoint = _.cloneDeep(viewpoint);
        NotificationEventBus.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            let res = await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description,
            });
            if (
                sampleViewpoint.addToList &&
                this.activeViewpointList?.length > 0 &&
                this.addToList
            ) {
                decisionsModule.addViewpointToActiveLists(res.viewpointId);
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        // console.log(viewpoint);
        this.adding = false;
    }

    private async addToLists(payload: string[]) {
        console.log(payload);
        await decisionsModule.addViewpointsToSelectLists({
            viewpoints: this.selectedViewpoints,
            listIds: payload,
        });
    }

    private async generateViewpoint(payload: any) {
        NotificationEventBus.emitProcessingMessage();
        this.generateViewpointDialog = false;
        try{
            await viewpointsModule.generateViewpoint(payload)
           NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }
}
